import { defineComponent as X, useSlots as Z, useTemplateRef as E, ref as x, computed as r, useId as R, onMounted as ee, watch as te, createElementBlock as p, createCommentVNode as n, openBlock as o, createElementVNode as C, createBlock as v, resolveDynamicComponent as y, withCtx as le, createTextVNode as ae, toDisplayString as V, toRaw as A, normalizeClass as k, createVNode as re } from "vue";
import { useSwipe as se, useResizeObserver as oe, useMutationObserver as ne } from "@vueuse/core";
import "@ds/components/Button";
import { deprecatePropNames as ie } from "../../composables/usePropsDeprecation.js";
import { tw as g } from "../../utils/tailwind.js";
import { skipFragment as ce, isVNodeEmpty as ue } from "../../utils/vnode.js";
import { desktopCardWidths as L, mobileCardWidths as z, cardWidths as de, SCROLL_ANNOUNCEMENT_DELAY as me } from "./CardCarousel.constant.js";
import D from "./components/CardCarouselController.vue2.js";
import ve from "./components/CardCarouselItems.vue2.js";
const fe = ["aria-labelledby"], pe = {
  key: 0,
  class: "mb-16 inline-flex flex-row items-end gap-16 md:gap-28"
}, he = { class: "flex grow flex-col" }, be = ["id"], xe = ["aria-label"], Ce = {
  key: 1,
  class: "mt-8 isolate flex"
}, Ve = /* @__PURE__ */ X({
  name: "CardCarousel",
  __name: "CardCarousel",
  props: {
    center: { type: Boolean, default: !0 },
    desktopCardWidth: { default: "standard" },
    mobileCardWidth: { default: "standard" },
    prevAlternativeText: {},
    nextAlternativeText: {},
    size: { default: "small" },
    title: { default: "" },
    titleTag: { default: "h2" },
    ariaLabelledby: { default: void 0 },
    subtitle: { default: "" }
  },
  emits: ["slide-impression"],
  setup(t, { emit: I }) {
    const a = t, h = Z(), w = I, s = E("carousel-scroller"), $ = E(
      "carousel-items"
    ), i = x(!1), c = x(!1), { direction: O } = se(s, { threshold: 50 }), W = r(() => `${R()}_title`), T = r(() => `${R()}_subtitle`), d = r(() => i.value || c.value), M = r(() => [
      i.value && c.value && g`gradient-mask-lr-80`,
      i.value && !c.value && g`gradient-mask-l-90`,
      !i.value && c.value && g`gradient-mask-r-90`
    ]), N = x(""), S = r(
      () => ce(h?.default({})).filter(
        (e) => !ue(e)
      )
    ), B = (e) => {
      const l = {
        backward: -1 * (s?.value?.clientWidth ?? 0),
        forward: s?.value?.clientWidth ?? 0
      };
      w("slide-impression", { direction: e }), s?.value?.scrollBy({
        behavior: "smooth",
        left: l[e],
        top: 0
      });
    }, P = (e, l) => {
      const u = e.getBoundingClientRect();
      return u.left >= l.left && u.right <= l.right && u.top >= l.top && u.bottom <= l.bottom;
    }, _ = (e) => {
      B(e), setTimeout(() => {
        const l = s.value, u = $.value?.$el;
        if (!l || !u) return;
        const K = l.getBoundingClientRect(), Q = Array.from(u.children).filter(
          (b) => P(b, K)
        ).map((b) => b.textContent?.trim()).filter(Boolean).join(", ");
        N.value = Q;
      }, me);
    }, F = async () => {
      const e = s?.value?.scrollWidth ?? 0, l = (s?.value?.clientWidth ?? 0) + (s?.value?.scrollLeft ?? 0);
      c.value = l < e;
    }, j = () => {
      i.value = s?.value?.scrollLeft !== 0;
    }, f = () => {
      F(), j();
    };
    ee(() => {
      f();
    }), te(O, (e) => {
      if (!e || e === "none") return;
      w("slide-impression", { direction: e === "left" ? "forward" : "backward" });
    });
    const m = r(() => h?.button?.({})?.[0] ? h.button({})[0] : null), U = r(() => !S.value?.length), Y = r(() => a.desktopCardWidth === "narrow" ? [
      L[a.desktopCardWidth],
      z[a.mobileCardWidth]
    ] : [
      L[a.desktopCardWidth],
      z[a.mobileCardWidth],
      de[a.size]
    ]), q = r(() => m.value && !d.value), G = r(() => m.value || d.value && !a.title), H = r(() => ["hidden md:flex", a.title && "md:ml-auto"]), J = r(() => [
      a.title && "md:ml-auto",
      a.title && !d.value && "md:hidden"
    ]);
    return oe(s, () => {
      f();
    }), ne(
      s,
      () => {
        f();
      },
      { attributes: !0, childList: !0, subtree: !0 }
    ), ie([
      {
        reason: "Replaced by `size`, with new values `extra-small`, `small`, `medium`, `large` and `extra-large`",
        deadline: "2025-05-01",
        replacementName: "size",
        props: {
          propName: "desktopCardWidth",
          propValue: a.desktopCardWidth,
          propDefaultValue: "standard"
        }
      },
      {
        reason: "Replaced by `size`, with new values `extra-small`, `small`, `medium`, `large` and `extra-large`",
        deadline: "2025-05-01",
        replacementName: "size",
        props: {
          propName: "mobileCardWidth",
          propValue: a.mobileCardWidth,
          propDefaultValue: "standard"
        }
      }
    ]), (e, l) => U.value ? n("", !0) : (o(), p("section", {
      key: 0,
      "aria-labelledby": `${W.value} ${T.value}`,
      "aria-roledescription": "carousel",
      class: "relative flex flex-col",
      "data-test": "card-carousel"
    }, [
      t.title ? (o(), p("div", pe, [
        C("div", he, [
          (o(), v(y(t.titleTag), {
            id: W.value,
            class: "mb-8 text-static-default-hi heading-2 md:mb-0"
          }, {
            default: le(() => [
              ae(V(t.title), 1)
            ]),
            _: 1
          }, 8, ["id"])),
          t.subtitle ? (o(), p("span", {
            key: 0,
            id: T.value,
            class: "text-static-default-low body-1"
          }, V(t.subtitle), 9, be)) : n("", !0)
        ]),
        d.value ? (o(), v(D, {
          key: 0,
          "can-scroll-next": c.value,
          "can-scroll-prev": i.value,
          "next-alternative-text": t.nextAlternativeText,
          "prev-alternative-text": t.prevAlternativeText,
          onScroll: _
        }, null, 8, ["can-scroll-next", "can-scroll-prev", "next-alternative-text", "prev-alternative-text"])) : n("", !0),
        q.value ? (o(), v(y(A(m.value)), {
          key: 1,
          class: k(H.value),
          "full-width": "adaptive"
        }, null, 8, ["class"])) : n("", !0)
      ])) : n("", !0),
      C("div", {
        ref: "carousel-scroller",
        class: k(["-m-12 focus-visible-outline-inset-hi rounded-sm snap-x snap-mandatory scroll-pl-12 overflow-x-auto overscroll-x-contain scroll-smooth transition-transform duration-700 scrollbar-none", M.value]),
        onScroll: f
      }, [
        re(ve, {
          ref: "carousel-items",
          "aria-labelledby": t.ariaLabelledby,
          "card-classes": Y.value,
          center: t.center ? !d.value : !1,
          class: "p-12",
          items: S.value
        }, null, 8, ["aria-labelledby", "card-classes", "center", "items"]),
        C("div", {
          "aria-label": N.value,
          "aria-live": "polite",
          class: "sr-only"
        }, null, 8, xe)
      ], 34),
      G.value ? (o(), p("div", Ce, [
        m.value ? (o(), v(y(A(m.value)), {
          key: 0,
          class: k(J.value),
          "full-width": "adaptive"
        }, null, 8, ["class"])) : n("", !0),
        d.value && !t.title ? (o(), v(D, {
          key: 1,
          "can-scroll-next": c.value,
          "can-scroll-prev": i.value,
          class: "ml-auto",
          "next-alternative-text": t.nextAlternativeText,
          "prev-alternative-text": t.prevAlternativeText,
          onScroll: B
        }, null, 8, ["can-scroll-next", "can-scroll-prev", "next-alternative-text", "prev-alternative-text"])) : n("", !0)
      ])) : n("", !0)
    ], 8, fe));
  }
});
export {
  Ve as default
};
